<template>
  <cell
    :title="label"
    :center="center"
    :required="required"
    :paddingType='paddingType'
    :class="b({
      error,
      disabled: $attrs.disabled,
      'has-icon': hasIcon,
      'min-height': type === 'textarea' && !autosize
    })"
  >
    <textarea
      v-if="type === 'textarea'"
      v-bind="$attrs"
      v-on="listeners"
      ref="textarea"
      :class="b('control', {'input-right': inputRight})"
      :value="value"
    />
    <input ref='Input'
      v-else
      v-bind="$attrs"
      v-on="listeners"
      :class="b('control', {'input-right': inputRight})"
      :type="type"
      :value="value"
    />
    <div
      v-if="errorMessage"
      v-text="errorMessage"
      :class="b('error-message')"
    />
    <div
      v-if="hasIcon"
      v-show="$slots.icon || value"
      :class="b('icon')"
      @touchstart.prevent="onClickIcon"
    >
      <slot name="icon">
        <icon :name="icon" />
      </slot>
    </div>
    <div v-if="$slots.button" :class="b('button')" slot="extra">
      <slot name="button" />
    </div>
  </cell>
</template>

<script>
import create from '../utils/create';
import { isObj, isIphone } from '../utils';

export default create({
  name: 'field',

  inheritAttrs: false,

  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {},
    icon: String,
    label: String,
    error: Boolean,
    center: Boolean,
    inputRight: Boolean,
    border: Boolean,
    required: Boolean,
    autosize: [Boolean, Object],
    errorMessage: String,
    onIconClick: {
      type: Function,
      default: () => {}
    },
    paddingType: {
      type: String,
      default: ''
    }
  },

  watch: {
    value() {
      this.$nextTick(this.adjustSize);
    }
  },

  mounted() {
    this.$nextTick(this.adjustSize);
  },

  computed: {
    hasIcon() {
      return this.$slots.icon || this.icon;
    },

    listeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
        keypress: this.onKeypress,
        blur: this.iosKeyboardFixer
      };
    }
  },

  methods: {
    onInput(event) {
      this.$emit('input', event.target.value);
    },
    iosKeyboardFixer (e) {
      if (!isIphone()) {
        return
      }
      window.scroll(0, 0)
    },
    onClickIcon() {
      this.$emit('click-icon');
      this.onIconClick();
    },

    onKeypress(event) {
      if (this.type === 'number') {
        const { keyCode } = event;
        const tempValue = '' + this.value
        const allowPoint = tempValue.indexOf('.') === -1;
        const isValidKey = (keyCode >= 48 && keyCode <= 57) || (keyCode === 46 && allowPoint) || keyCode === 45;
        if (!isValidKey) {
          event.preventDefault();
        }
      }
      this.$emit('keypress', event);
    },

    adjustSize() {
      if (!(this.type === 'textarea' && this.autosize)) {
        return;
      }

      const el = this.$refs.textarea;
      /* istanbul ignore if */
      if (!el) {
        return;
      }

      el.style.height = 'auto';

      let height = el.scrollHeight;
      if (isObj(this.autosize)) {
        const { maxHeight, minHeight } = this.autosize;
        if (maxHeight) {
          height = Math.min(height, maxHeight);
        }
        if (minHeight) {
          height = Math.max(height, minHeight);
        }
      }

      if (height) {
        el.style.height = height + 'px';
      }
    },
    onFocus () {
      this.$refs.Input.focus()
    }
  }
});
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/field/index.vue